const getSsoUrl = () => {
  return (
    process.env.REACT_APP_SSO_URL ||
    'https://mycnc-web-qa1.dev.aws.castandcrew.com'
  );
};

module.exports = getSsoUrl;
